import IconText from "./IconText"
import IconImage from "./IconImage"

import { getIconOpacity, getTextOpacity } from "../../../noncomponents/getOpacity"

export default function CirkelMetIconen({ data, middleRadius, circleID, iconData, circleWidth, iconPositions,
  hoverSelection, setHoverSelection, clickSelection, setClickSelection, connectionChains,
  chainSelection, setChainSelection, circleWidthImpacts, landschapOptions,
  partijenOptions, setLandschapOptions, setPartijenOptions }) {

  const circleR = circleWidth/2;

  return (
    <g className="CirkelMetIconen">
      {iconData.map((d, i) => {
        // gather radius and theta and calculate cartesian position
        const r = iconPositions[d.ID][0];
        const theta = iconPositions[d.ID][1];
        const x = r * Math.cos(theta);
        const y = r * Math.sin(theta);

        const iconOpacity = getIconOpacity(d, i, connectionChains, clickSelection,
          hoverSelection, chainSelection);
        const textOpacity = getTextOpacity(d, connectionChains, clickSelection,
          hoverSelection, chainSelection);

        let textX = 0;
        let textY = circleR + 10;
        if(d.typenr === '4'){textY = circleWidthImpacts/2 + 10}
        let fontSize = 12;

        return (
          <g transform={`translate(${x},${y})`}
            key={d+i}>

            <IconImage data={data} d={d} i={i} iconOpacity={iconOpacity} circleR={circleR}
              circleWidth={circleWidth} setHoverSelection={setHoverSelection}
              setClickSelection={setClickSelection} connectionChains={connectionChains}
              clickSelection={clickSelection} chainSelection={chainSelection}
              setChainSelection={setChainSelection} hoverSelection={hoverSelection}
              circleWidthImpacts={circleWidthImpacts}
              partijenOptions={partijenOptions} setPartijenOptions={setPartijenOptions}
              landschapOptions={landschapOptions} setLandschapOptions={setLandschapOptions} />

            <IconText d={d} textX={textX} textY={textY} textOpacity={textOpacity}
              fontSize={fontSize} />

          </g>
        )
      })}

    </g>
  );
}
